import {firstValueFrom} from 'rxjs';
import {IBaseCRUDComponent} from '../../../../../sdk/src/components/ibase-crud/ibase-crud.component';
import {
    NewEditServiceRequestGroupModalComponent,
    NewEditServiceRequestGroupModalConfig,
    NewEditServiceRequestGroupModalResult
} from '../../../modals/new-edit-service-request-group-modal/new-edit-service-request-group-modal.component';
import {Component} from '@angular/core';
import {ETableColFilterType} from '../../../../../sdk/src/components/generic-table/table-col-def';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {EDeleteMode} from '../../../../../sdk/src/enums/delete-mode.enum';
import {CpmCServiceRequestGroupApiService} from '../../../../../gen/cpm-c-api-ts/src/services/c-customer/cpmc-service-request-group.api-service';
import {CpmCServiceRequestGroupApiModel} from '../../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-service-request-group.api-model';
import {SdkImportsModule} from '../../../../../sdk/src/sdk-imports';

/**
 * ServiceRequestGroup CRUD table component
 */
@Component({
    selector: 'app-service-request-group-crud',
    templateUrl: './service-request-group-crud.component.html',
    imports: [PrimeNgImportsModule, SdkImportsModule]
})
export class ServiceRequestGroupCRUDComponent extends IBaseCRUDComponent<
    CpmCServiceRequestGroupApiModel,
    NewEditServiceRequestGroupModalComponent,
    NewEditServiceRequestGroupModalConfig,
    NewEditServiceRequestGroupModalResult
> {
    protected helpVisible = false;

    // ===============================================================
    // ===============================================================

    /**
     * Constructor
     */
    constructor() {
        super();

        this.configure({
            // Model config
            modelName: 'ServiceRequestGroupApiModel',
            getModelHumanIdentifier: (model: CpmCServiceRequestGroupApiModel) =>
                model.name ?? '<Unknown service request group>',

            // Service config
            deleteMode: EDeleteMode.CONFIRM_REENFORCED,
            deleteModelService: (modelToDelete: CpmCServiceRequestGroupApiModel) =>
                CpmCServiceRequestGroupApiService.deleteServiceRequestGroup(modelToDelete.uuid!),

            // Modal config
            modalType: NewEditServiceRequestGroupModalComponent,
            getDialogServiceParameters: NewEditServiceRequestGroupModalComponent.getDialogServiceParameters,
            modalExtendedConfigBuilder: (model?: CpmCServiceRequestGroupApiModel) =>
                new NewEditServiceRequestGroupModalConfig(model),

            // Authorization config
            authorizationNew: CpmCServiceRequestGroupApiService.endpointNew(this.FAKE_UUID),
            authorizationEdit: CpmCServiceRequestGroupApiService.endpointEdit(this.FAKE_UUID, this.FAKE_UUID),
            authorizationDelete: CpmCServiceRequestGroupApiService.endpointDelete(this.FAKE_UUID, this.FAKE_UUID)
        });
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * On refresh (Error handling is done in the parent)
     */
    public override async onRefresh(): Promise<void> {
        this.loadingStr = 'Loading service request groups...';

        const result = await firstValueFrom(
            CpmCServiceRequestGroupApiService.getServiceRequestGroupList({}, this.paginatorConfig)
        );

        this.items = result.data;
        this.totalItemCount = result.total;
    }

    // ===============================================================
    // ===============================================================

    /**
     * On help button pressed
     */
    public override async onHelp(): Promise<void> {
        this.helpVisible = true;
    }

    // ===============================================================
    // ===============================================================

    /**
     * Init the columns (Error handling is done in the parent)
     */
    protected override async initColumns(): Promise<void> {
        this.tableCols = [
            {
                field: 'name',
                header: 'Name',
                searcheable: true,
                filterable: true,
                filterType: ETableColFilterType.TEXT
            },
            {
                field: 'description',
                header: 'Description',
                searcheable: true,
                filterable: true,
                filterType: ETableColFilterType.TEXT
            }
        ];

        this.addCreatedColumns();
    }
}
